import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthStateFacade } from '@zero/shared/util-global-state';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { Tag, TagType, TagsResponse } from '../entities/tags.entity';

@Injectable({ providedIn: 'root' })
export class TagsInfrastructure {
  readonly #http = inject(HttpClient);
  readonly #authStateFacade = inject(AuthStateFacade);
  readonly #api = `${environment.apihost}/api`;
  readonly #cacheKeyPrefix = 'activated-tags';

  public getTags = (type: TagType): Observable<TagsResponse> => this.#http.get<TagsResponse>(`${this.#api}/tags?type=${type}`);

  public addTag = (tagId: string, entityId: string, name: string, type: TagType): Observable<Tag> =>
    this.#http.post<Tag>(`${this.#api}/tag/link`, { tagId, entityId, name, type });

  public deleteTag = (tagId: string): Observable<void> => this.#http.delete<void>(`${this.#api}/tag/${tagId}`);

  public deleteLinkedTag = (tagId: string, entityId: string): Observable<void> =>
    this.#http.delete<void>(`${this.#api}/tag/${tagId}/link/${entityId}`);

  public getActivatedTags = (type: TagType, tags: Tag[]): Observable<string[]> =>
    of(this.getActivatedTagIds(type).filter((tagId: string) => tags.some((tag) => tag.tagId === tagId)));

  public removeActiveTag(type: TagType, tagId: string): Observable<string[]> {
    const tagIds = this.getActivatedTagIds(type);
    return of(tagIds.splice(tagIds.indexOf(tagId), 1));
  }

  public resetTags = (): Observable<string[]> => of([]);

  public activateAllTags = (tags: Tag[]): Observable<string[]> => of(tags.map(({ tagId }) => tagId));

  public toggleTag(type: TagType, tagId: string): Observable<string[]> {
    const tagIds = this.getActivatedTagIds(type);
    tagIds.includes(tagId) ? tagIds.splice(tagIds.indexOf(tagId), 1) : tagIds.push(tagId);
    return of(tagIds);
  }

  public getActivatedTagIds = (type: TagType): string[] => {
    const cached = localStorage.getItem(this.#getCacheKey(type));
    return cached ? JSON.parse(cached) : [];
  };

  public cache = (type: TagType, tagIds: string[]): void => localStorage.setItem(this.#getCacheKey(type), JSON.stringify(tagIds));

  readonly #getCacheKey = (type: TagType): string => `${this.#cacheKeyPrefix}-${type}-${this.#authStateFacade.customerId}`;
}
